const { commonConfig } = require('@alfa-bank/assr-common-config');
const { cdnPlugin } = require('@plotva/assr-core-plugins');
const { captureConsoleIntegration, browserTracingIntegration } = require('@sentry/browser');

const { getCounters } = require('./src/counters/index.cjs');
const { favicon } = require('./src/favicon.cjs');
const { pendingRoutePlugin } = require('./src/plugins/pending-route.cjs');

const { name, version, dependencies, resolutions } = require('./package.json');

/** @type {import('@plotva/assr-core').IAssrConfig} */
const config = {
    ...commonConfig,
    postcss: {
        customPropertiesFile: 'node_modules/@alfalab/core-components-themes/site.css'
    },
    cssHashLen: 5,
    widgetsContexts: ['@alfa-bank', '@plotva'],
    additionalWidgetPackages: [],
    instanceName: name,
    instanceVersion: version,
    getDependencies: () => ({ ...dependencies, ...resolutions }),
    plugins: [
        {
            plugin: pendingRoutePlugin
        },
        {
            plugin: cdnPlugin,

            config: {
                cdnPublicPath: process.env.CDN_PUBLIC_PATH,
                domainPattern: '(https?:)?//alfabank[.]st'
            }
        }
    ],
    getCounters,
    getFavicon: () => favicon,
    sentry: {
        client: {
            enabled: true,
            sampleRate: 0.5,
            normalizeDepth: 4,
            tracesSampleRate: 0.05,
            integrations: [captureConsoleIntegration({ levels: ['error'] }), browserTracingIntegration()]
        }
    },
};

module.exports = config;
